import React from "react";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { MdLightbulbOutline } from "react-icons/md";
import { VscCode } from "react-icons/vsc";
import { FiBarChart2 } from "react-icons/fi";

function Benifits() {
  return (
    <>
      <div className="container text-center mt-5 benefits-section">
        <h2>DISCOVER YOUR ADVANTAGES</h2>
        <h1 className="mb-5">The Benefits Awaited for You!</h1>
        <div className="row">
          <div className="col-md-6 col-lg-3 mb-4">
            <div className="benefit-card h-100">
              <div className="icon mb-3">
                <IoChatbubbleEllipsesOutline style={{ width: "48px", height: "48px", color: "#6f42c1" }} />
              </div>
              <h3>Get Personal Mentorship</h3>
              <p>Get personalized attention. Your solution will be viewed and guided by our mentors individually, and learn at your own pace.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 mb-4">
            <div className="benefit-card h-100">
              <div className="icon mb-3">
                <MdLightbulbOutline style={{ width: "48px", height: "48px", color: "#6f42c1" }} />
              </div>
              <h3>Clear Your Basic Concepts</h3>
              <p>Attempt new questions every day and clear your basic concepts which are required to crack any company interview. Start today and get placed tomorrow.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 mb-4">
            <div className="benefit-card h-100">
              <div className="icon mb-3">
                <VscCode style={{ width: "48px", height: "48px", color: "#6f42c1" }} />
              </div>
              <h3>Do Hands on Code practice</h3>
              <p>You don't get better at swimming by watching others. Coding is no different. Practice as you learn with live code environments inside your browser.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 mb-4">
            <div className="benefit-card h-100">
              <div className="icon mb-3">
                <FiBarChart2 style={{ width: "48px", height: "48px", color: "#6f42c1" }} />
              </div>
              <h3>Do self analysis</h3>
              <p>Compare your solutions with community solutions and improve your coding as you move forward and solve new problems.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Benifits;
